module.exports = __webpack_public_path__ + "static/img/img_title_training.abb085a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/img_title_training.png
// module id = 569
// module chunks = 1